import { SET_EVENTLIST } from '../actions';

const eventlist = (state = [], action) => {
  switch (action.type) {
	case SET_EVENTLIST:
      return [...action.value];  
    default: return state;
  }
}

export default eventlist;
